import React from 'react';
import { useTranslation } from "react-i18next";
import Section from "../../Atoms/Section";
import BigH1 from "../../Atoms/BigH1";

const Header = (props) => {

    const { i18n } = useTranslation('common');

    return (
        <div>
            <Section className="padding">
                <BigH1 style={{fontSize:"65px", lineHeight:"70px", marginBottom:"20px"}}>{i18n.language === "fr" ? "SPEED DATING Objet" : "SPEED DATING Object"}</BigH1>
                <span style={{fontSize:"22px"}}>{props.overrideSentence ? props.overrideSentence : (i18n.language === "fr" ? "Pour vous inscrire, compléter les informations ci-dessous" : "To register, please fill the information below.")}</span>
            </Section>
        </div>
    );
};

export default Header;